import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Modal, Tag} from 'antd'
import { QuestionCircleFilled, EditOutlined, DeleteOutlined, ExclamationCircleFilled, EyeOutlined, CheckCircleOutlined, CloseCircleOutlined} from '@ant-design/icons'
import FormModal from './FormModal'
import ViewModal from './ViewModal'
import {withTranslation} from 'react-i18next'
const {confirm} = Modal

@inject('emailTemplateStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
    detailsModalVisible: false, 
  }

  componentDidMount() {
  }
  // 编辑
  handleEdit = (record) => {
    const {emailTemplateStore} = this.props
    const {searchItem} = emailTemplateStore
    emailTemplateStore.onGetJobAction({
      id: record.id,
      marketGroupId: searchItem?.marketGroupId
    }).then(res => {
      this.setState({
        addModalVisible: true,
      })
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  // 预览
  handleDetails = (record) => {
    const {emailTemplateStore} = this.props
    const {searchItem} = emailTemplateStore
    emailTemplateStore.onGetJobAction({
      id: record.id,
      marketGroupId: searchItem?.marketGroupId
    }).then(res => {
      this.setState({
        detailsModalVisible: true,
      })
    })
  }
  
  handleCancelResourcePool = () => {
    this.setState({
      detailsModalVisible: false
    })
  }
  handleDel = (record) => {
    const {emailTemplateStore,t} = this.props
    const {searchItem} = emailTemplateStore
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        emailTemplateStore.onDeleteJobAction({
          "id": record?.id,
          "marketGroupId": searchItem?.marketGroupId
        })
      },
      onCancel() {
      },
    })
    return false
  }
  handlePageChange = (page, pageSize) => {
    const {emailTemplateStore} = this.props
    emailTemplateStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const {emailTemplateStore, t} = this.props
    const {searchItem, pageNo, pageSize, itemCount, jobList, groupList, statusList, templateStatusList} = emailTemplateStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <div className="searchResult">
        <div className='tips_box'>
          <div className='f_red'><ExclamationCircleFilled /> 温馨提示:</div>
          <div>1、模板保存后自动开始邮件垃圾度检测，检测耗时一般为1-5秒左右，视模板的复杂度和大小而定；</div>
          <div>2、扣量类型：邮件大小在100KB以内扣除1点，超过100KB按“邮件大小 / 100KB”扣量，不满100KB的部分按100KB计算；如130KB扣2点，280KB扣3点；</div>
          <div>3、上面显示的邮件大小为邮件封装后的大小，添加了邮件头/统计代码后的大小；</div>
          <div className='f_red'>检测结果说明：</div>
          <div><span className='mail_t_bg green'></span> 绿色：该模板邮件检测合格，可以发送</div>
          <div><span className='mail_t_bg yellow'></span> 黄色：该模板邮件发送可能存在被拦截的风险</div>
          <div><span className='mail_t_bg red_pass'></span> 红色：该模板邮件发送可能存在被各大服务商直接拦截的风险，建议重新编辑后再发送（禁止发送）</div>
        </div>
        <Table dataSource={toJS(jobList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName} bordered>
          <Table.Column title={t(`emailSend.marketingGroup`)} dataIndex="groupName" key="groupName" ellipsis={true} render={(text, record) => (
            <>
            {groupList?.find(a=>a?.id===searchItem?.marketGroupId)?.groupName}
            </>
          )} />
          <Table.Column title={t(`emailSend.templateId`)} dataIndex="id" key="id" ellipsis={true} />
          <Table.Column width={180} title={t(`emailSend.templateName`)} dataIndex="name" key="name" ellipsis={true} />
          <Table.Column width={120} title={t(`emailSend.status`)} dataIndex="status" key="status" ellipsis={true} render={(text, record) => {
            const val = templateStatusList?.find(a=> a?.id ===record?.id)?.data?.status
            return val && val !=='-1' ? <Tag  color={val==='1' ? "success" : val==='0' ? "error" : null }>
              {val ? val==='1' ? <CheckCircleOutlined /> : val==='0'? <CloseCircleOutlined /> : null : null}
              {' '}
              {statusList?.find(a=> a?.code ===val)?.name}
            </Tag> : null
          }} />
          <Table.Column title={t(`emailSend.templateTheme`)} dataIndex="subject" key="subject" ellipsis={true} render={(text, record) => (
            <>{text?.name}</>
          )} />
          <Table.Column title={t(`emailSend.templateSize`)} dataIndex="size" key="size" ellipsis={true} render={(text, record) => (
            <>{templateStatusList?.find(a=> a?.id ===record?.id)?.data?.size} kb</>
          )} />
          <Table.Column width={180} title={t(`emailSend.createTime`)} dataIndex="createTime" key="createTime" ellipsis={true} />
          <Table.Column title={t(`emailSend.sendingEffect`)} dataIndex="status" key="status" ellipsis={true} render={(text, record) => {
            const val = templateStatusList?.find(a=> a?.id ===record?.id)?.data?.colour
            return <span className={val==='green' ? 'mail_t_bg green' : text==='yellow' ? 'mail_t_bg yellow' : text==='red_pass' ? 'mail_t_bg red_pass' : null}></span>
          }} />
          <Table.Column width={200} align="center" fixed='right' title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleEdit(record)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
              <Button type="link" onClick={() => this.handleDetails(record)} icon={<EyeOutlined />} title={t(`general.details`)}/>
              <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
            </>
          )}/>
        </Table>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title="edit"
        /> : null}
        {this.state.detailsModalVisible ? 
          <ViewModal handleCancel={this.handleCancelResourcePool} addModalVisible={this.state.detailsModalVisible} /> 
        : null}
      </div>
    )
  }
}

export default withTranslation()(SearchResult)
